/* NURA cart: cross-sell add button, delivery dates, offered app, live refresh on the cart page */
(function () {
  if (window.__nuraCart) return;
  window.__nuraCart = true;

  /* small style for the one-click "add the offered app" button in the cart bar */
  var st = document.createElement('style');
  st.textContent = '.nc-bar__msg .nc-add{margin-left:6px;background:#C9A96E;color:#111;border:0;border-radius:6px;padding:6px 11px;font:700 11.5px/1 Montserrat,sans-serif;cursor:pointer;display:inline-block}';
  document.head.appendChild(st);

  /* ---- estimated delivery window: +3 to +7 working days (ship 24-48 h + 2-5 working days) ---- */
  function addWorkingDays(from, n) {
    var d = new Date(from.getTime()), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { return d.toDateString(); }
  }
  function fillDates() {
    var els = document.querySelectorAll('[data-nc-dates]');
    if (!els.length) return;
    var now = new Date();
    var txt = 'entre le ' + fmt(addWorkingDays(now, 3)) + ' et le ' + fmt(addWorkingDays(now, 7));
    els.forEach(function (el) { if (el.textContent !== txt) el.textContent = txt; });
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(fillDates, 40); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', fillDates);
  fillDates();

  /* ---- one rule: the app is offered with every pan, board or pack -> add it automatically ---- */
  var APP = 58790171935051;
  var PHYS = [58048848429387, 57278233805131, 58305339818315];
  function refresh(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) drawer.renderContents(state);
    else window.location.reload();
  }
  function ensureApp(variantId) {
    if (PHYS.indexOf(Number(variantId)) < 0) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var has = (c.items || []).some(function (i) { return i.variant_id === APP; });
      if (has) return;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify({ id: APP, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (state) { if (!state.status && !state.errors) refresh(state); });
    }).catch(function () {});
  }
  function hook() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || window.__nuraAppHook) return false;
    window.__nuraAppHook = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.source === 'product-form' && e.productVariantId) ensureApp(e.productVariantId);
    });
    return true;
  }
  if (!hook()) { document.addEventListener('DOMContentLoaded', hook); window.addEventListener('load', hook); }

  /* ---- cross-sell: add the suggested product ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nc-add]');
    if (!b || b.classList.contains('is-loading')) return;
    e.preventDefault();
    b.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var body = JSON.stringify({
      id: Number(b.getAttribute('data-nc-add')),
      quantity: 1,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || state.errors) { b.classList.remove('is-loading'); b.textContent = 'Indisponible'; return; }
        if (drawer && drawer.contains(b) && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { b.classList.remove('is-loading'); });
  });

  /* ---- cart page: refresh the extra blocks when the cart changes ---- */
  class NuraCartLive extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      var self = this;
      this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        var id = self.getAttribute('data-section-id');
        if (!id) return;
        fetch(window.location.pathname + '?section_id=' + id)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var src = new DOMParser().parseFromString(html, 'text/html').querySelector('nura-cart-live');
            if (src) self.innerHTML = src.innerHTML;
          });
      });
    }
    disconnectedCallback() { if (this.unsub) this.unsub(); }
  }
  if (!customElements.get('nura-cart-live')) customElements.define('nura-cart-live', NuraCartLive);
})();